var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-form-model", {
    ref: "accountFrom",
    staticClass: "account-from",
    attrs: {
      model: _vm.accountFrom,
      rules: _vm.accountRule,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      },
      hideRequiredMark: ""
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "imgUrl",
      label: _vm.$t("头像")
    }
  }, [_c("a-avatar", {
    attrs: {
      src: _vm.accountFrom.imgUrl,
      size: 108
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "username",
      label: _vm.$t("用户名"),
      hasFeedback: ""
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("用户名"),
      "allow-clear": ""
    },
    model: {
      value: _vm.accountFrom.username,
      callback: function ($$v) {
        _vm.$set(_vm.accountFrom, "username", $$v);
      },
      expression: "accountFrom.username"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("权限")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.accountFrom.role,
      callback: function ($$v) {
        _vm.$set(_vm.accountFrom, "role", $$v);
      },
      expression: "accountFrom.role"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "position",
      label: _vm.$t("职位"),
      hasFeedback: ""
    }
  }, [_c("a-input", {
    attrs: {
      "allow-clear": ""
    },
    model: {
      value: _vm.accountFrom.position,
      callback: function ($$v) {
        _vm.$set(_vm.accountFrom, "position", $$v);
      },
      expression: "accountFrom.position"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "location",
      label: _vm.$t("所在城市")
    }
  }, [_c("a-input", {
    attrs: {
      "allow-clear": ""
    },
    model: {
      value: _vm.accountFrom.location,
      callback: function ($$v) {
        _vm.$set(_vm.accountFrom, "location", $$v);
      },
      expression: "accountFrom.location"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "label",
      label: _vm.$t("个人介绍")
    }
  }, [_c("a-textarea", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("个人介绍") + "...",
      autoSize: {
        minRows: 4,
        maxRows: 7
      }
    },
    model: {
      value: _vm.accountFrom.label,
      callback: function ($$v) {
        _vm.$set(_vm.accountFrom, "label", $$v);
      },
      expression: "accountFrom.label"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "skill",
      label: _vm.$t("技能")
    }
  }, [_c("a-select", {
    attrs: {
      mode: "tags",
      placeholder: _vm.$t("请输入") + _vm.$t("个人技能"),
      maxTagCount: 3,
      allowClear: "",
      "default-value": _vm.accountFrom.skill
    },
    on: {
      change: _vm.changeSkill
    }
  }, _vm._l(_vm.skillList, function (item) {
    return _c("a-select-option", {
      key: item
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  }), 1)], 1), _c("a-form-item", {
    staticClass: "text-center"
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.loading
    },
    on: {
      click: _vm.updateValue
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("提交")) + " ")]), _c("a-button", {
    staticStyle: {
      "margin-left": "25px"
    },
    on: {
      click: _vm.resetFrom
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("取消")) + " ")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };